import { z } from "zod/v4";
import { bisTournamentSchema, teamEntrySchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const calendar = {
	list: (params?: { q?: string; federation?: string; sheet?: string; sort?: string }) => {
		const query = new URLSearchParams();
		if (params?.q) query.set("q", params.q);
		if (params?.federation) query.set("federation", params.federation);
		if (params?.sheet) query.set("sheet", params.sheet);
		if (params?.sort) query.set("sort", params.sort);
		const qs = query.toString();
		return fetchApi(`/calendar${qs ? `?${qs}` : ""}`, z.array(bisTournamentSchema));
	},
	get: (id: string) => fetchApi(`/calendar/${id}`, bisTournamentSchema),
	create: (body: any) =>
		fetchApi(`/calendar`, bisTournamentSchema, {
			method: "POST",
			body: JSON.stringify(body),
		}),
	update: (id: string, body: any) =>
		fetchApi(`/calendar/${id}`, bisTournamentSchema, {
			method: "PUT",
			body: JSON.stringify(body),
		}),
	remove: (id: string) =>
		fetchApi(`/calendar/${id}`, z.object({ deleted: z.boolean() }), {
			method: "DELETE",
		}),
	entries: (tournamentId: string) =>
		fetchApi(`/calendar/${tournamentId}/entries`, z.array(teamEntrySchema)),
	createEntry: (tournamentId: string, body: any) =>
		fetchApi(`/calendar/${tournamentId}/entries`, teamEntrySchema, {
			method: "POST",
			body: JSON.stringify(body),
		}),
	updateEntry: (tournamentId: string, entryId: string, body: any) =>
		fetchApi(`/calendar/${tournamentId}/entries/${entryId}`, teamEntrySchema, {
			method: "PUT",
			body: JSON.stringify(body),
		}),
	removeEntry: (tournamentId: string, entryId: string) =>
		fetchApi(`/calendar/${tournamentId}/entries/${entryId}`, z.object({ deleted: z.boolean() }), {
			method: "DELETE",
		}),
};
